import React, { useEffect } from "react";
import SideBar from "./sidebar";
import NavBar from "./navbar";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";

import { getApi, loggedUser } from "../Helpers/Axios";

const Index = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    // handleUserVerify();
    handleAdminInfo();
  }, []);

  // let handleUserVerify = () => {
  //   let token = localStorage.getItem(process.env.REACT_APP_SECRET_KEY);
  //   if (token === undefined || token === "" || token === null) {
  //     window.location.href = "/";
  //   }
  // };

  let handleAdminInfo = async () => {
    await getApi("get-admin", true).then((response) => {
      if (response.status === 200) {
        // Dispatch the Redux action and wait for it to complete
        dispatch(loggedUser(response?.data));

        if (
          response?.data?.is_admin === 1 &&
          response?.data?.is_superadmin === 0 &&
          location.pathname !== "/pending-members"
        ) {
          window.location.href = "/";
          localStorage.removeItem(process.env.REACT_APP_SECRET_KEY);
        }
      }
    });
  };

  return (
    <>
      <NavBar />
      <SideBar />
      <div className="container_wrapper">{children}</div>
    </>
  );
};

export default Index;
